import React, { Component } from 'react';
import { Col, Row, Menu, Layout, Icon, Spin } from 'antd';
import { Link } from 'react-router-dom'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import Index from "../index"
import Aboutus from "../aboutus"
import Case from "../case"
import Category from "../category"
import Foot from "../foot"
import QueueAnim from 'rc-queue-anim';
import axios from "axios"
import logo from '../../logo.png';



const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

const baseURL = process.env.REACT_APP_API_URL;

class Frame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grid: props.grid || 1,
            isLoading: true,
            categorys: [],
            cases: []
        };
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.grid !== this.state.grid) {
            this.setState({ grid: nextProps.grid });
        }
    }
    componentDidMount() {
        // axios.get(`http://www.as-gold.net/api/data.php?t=categorys`).then(res => {
        //     const categorys = res.data;
        //     var categorys_tree = [];
        //     categorys.forEach(category => {
        //         if (category.parent_id == null) {
        //             category.children = [];
        //             categorys_tree[category.id] = category;
        //         }
        //     });
        //     categorys.forEach(category => {
        //         if (category.parent_id != null) {
        //             categorys_tree[category.parent_id].children.push(category);
        //         }
        //     });
        //     this.setState({ categorys: categorys_tree });
        // })

        axios.post(baseURL + 'categorys/list',{}).then(res => {
            const categorys = res.data.list;
            var categorys_tree = [];
            categorys.forEach(category => {
                if (category.parentId == null) {
                    category.children = [];
                    categorys_tree[category.id] = category;
                }
            });
            categorys.forEach(category => {
                if (category.parentId != null) {
                    categorys_tree[category.parentId].children.push(category);
                }
            });
            this.setState({ categorys: categorys_tree });
        })

        // axios.get(`http://www.as-gold.net/api/data.php?t=cases`).then(res => {
        //     const cases = res.data;
        //     this.setState({ cases: cases, isLoading: false });
        // })
        let orderBy = "sort desc";
        let param = {orderBy: orderBy};
        axios.post(baseURL + 'cases/list',param).then(res => {
            const cases = res.data.list;
            this.setState({ cases: cases, isLoading: false });
        })
    }
    gridLage = (() => {
        this.setState({ grid: 2 });
    })
    gridSmall = (() => {
        this.setState({ grid: 1 });
    })
    render() {
        var categorys = this.state.categorys;
        return (
            <Router>
                <Row type="flex" justify="center" align="top" style={{ minHeight: "100vh" ,margin:16}}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ maxWidth: 1080 }} >
                        {this.state.isLoading ? <Spin /> :
                            <Layout style={{ minHeight: "100vh" }}>
                                <Header >
                                    <QueueAnim type="top" duration={1000} >
                                        <Link key="logo" to={"/"} >
                                            <img alt="logo" style={{ height: '32px', margin: "16px -128px 16px 0px", float: 'left' }} src={logo} />
                                        </Link>
                                        <div key="Menu" style={{marginLeft:256}} >
                                            <Menu
                                                mode="horizontal"
                                                style={{ textAlign: 'right' }}
                                            >
                                             <Menu.Item key="aboutus" onClick={this.gridLage}>
                                                <Link to={"/aboutus"}>关于我们</Link>
                                             </Menu.Item>
                                                {categorys.map(category => {
                                                    return (<SubMenu key={category.id} title={<span>{category.name}</span>} >
                                                        {category.children.map(sub_category => {
                                                            return (<Menu.Item key={sub_category.id} style={{ background: "#1d1d1d" }}><Link to={"/category/" + sub_category.id}>{sub_category.name}</Link></Menu.Item>)
                                                        })
                                                        }
                                                    </SubMenu>)
                                                })}
                                                <Menu.Item key="gridLage" onClick={this.gridLage}>
                                                    <Icon type="border" theme="outlined" />
                                                </Menu.Item>
                                                <Menu.Item key="gridSmall" onClick={this.gridSmall}>
                                                    <Icon type="appstore" theme="outlined" />
                                                </Menu.Item>
                                            </Menu>
                                        </div>
                                    </QueueAnim>
                                </Header>
                                <Content >
                                    <Switch>
                                        <Route path="/index" render={(props) => <Index  {...props} cases={this.state.cases} grid={this.state.grid} categorys={this.state.categorys} />} />
                                        <Route path="/aboutus" render={(props) => <Aboutus  {...props} categorys={this.state.categorys} />} />
                                        <Route path="/case/:case_id" render={(props) => <Case  {...props} grid={this.state.grid} categorys={this.state.categorys} cases={this.state.cases} />} />
                                        <Route path="/category/:category_id" render={(props) => <Category  {...props} grid={this.state.grid} cases={this.state.cases} categorys={this.state.categorys} />} />
                                    </Switch>
                                </Content>
                                <Footer >
                                    <Foot categorys={this.state.categorys} />
                                </Footer>
                            </Layout>
                        }
                    </Col>
                </Row>
            </Router >
        );
    }
}
export default Frame;
